import { FamilyDTO } from '../family-dto/family-dto';

/**
 * DTO response for equipments listing from API
 * @param {number} id number
 * @param {string} name string
 * @param {string[]} headers string[]
 * @param {string} image string
 * @param {string} family string
 * @param {boolean} active boolean
 *
 */
export class ProductDTO {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public id: number,
    public name: string,
    public headers: string[],
    public image: string,
    public family: string,
    public active: boolean,
    public rewardsQuantity: number,
    public productFamily?: FamilyDTO
  ) {}

  /**
   * Factory method for productList mock
   * @return {ProductDTO[]} ProductDTO[]
   */
  static MockProducts(): ProductDTO[] {
    return [
      {
        id: 2,
        name: 'S7230',
        headers: [
          'ABCE',
          'ASYA',
          'S123',
          'ABCE',
          'ASYA',
          'S123',
          'ABCE',
          'ASYA',
          'S123',
        ],
        image: '',
        family: 'SeriesS',
        active: true,
        rewardsQuantity: 5,
      },
      {
        id: 7,
        name: 'F920',
        headers: ['ABCE', 'ASYA', 'S123'],
        image: '',
        family: 'SeriesF',
        active: true,
        rewardsQuantity: 2,
      },
      {
        id: 22,
        name: 'S2000',
        headers: ['ABCE', 'ASYA', 'S123'],
        image: '',
        family: 'SeriesS',
        active: true,
        rewardsQuantity: 9,
      },
      {
        id: 1,
        name: 'F9098',
        headers: ['ABCE', 'ASYA', 'S123'],
        image: '',
        family: 'SeriesF',
        active: true,
        rewardsQuantity: 1,
      },
      {
        id: 5,
        name: 'S900X',
        headers: ['ABCE', 'ASYA', 'S123'],
        image: '',
        family: 'SeriesS',
        active: true,
        rewardsQuantity: 0,
      },
      {
        id: 2,
        name: 'S7230',
        headers: [
          'ABCE',
          'ASYA',
          'S123',
          'ABCE',
          'ASYA',
          'S123',
          'ABCE',
          'ASYA',
          'S123',
        ],
        image: '',
        family: 'SeriesS',
        active: true,
        rewardsQuantity: 5,
      },
      {
        id: 7,
        name: 'F920',
        headers: ['ABCE', 'ASYA', 'S123'],
        image: '',
        family: 'SeriesF',
        active: true,
        rewardsQuantity: 2,
      },
      {
        id: 22,
        name: 'S2000',
        headers: ['ABCE', 'ASYA', 'S123'],
        image: '',
        family: 'SeriesS',
        active: true,
        rewardsQuantity: 9,
      },
    ];
  }
}
